// tslint:disable:deprecation
import * as React from 'react';
import { TabStyles } from '../styles/TabStyles';
import { InteractiveDomHoCDecorator, InteractiveStyles } from '../utils/InteractiveDom';

/** @deprecated this is not a very useful Widget. Please contact #dev-shared-widgets if you have a use case. */
export interface InputLabelProps {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  id?: string;
  style?: React.CSSProperties;

  /** The testId of the label, will be appended with '-Label' */
  testId: string;
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  interactiveStyles?: InteractiveStyles;
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  handleHover?: (hover: boolean) => void;
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  handleActive?: (active: boolean) => void;
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  handleFocus?: (focus: boolean) => void;
  // tslint:disable:no-any
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerClick?: (event: React.SyntheticEvent<any>) => void;
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerDown?: (event: React.SyntheticEvent<any>) => void;
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerDoubleClick?: (event: React.SyntheticEvent<any>) => void;
  /** @deprecated post in #dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerUp?: (event: React.SyntheticEvent<any>) => void;
  // tslint:enable:no-any
}

const { Typography } = TabStyles;

const getStyle = (disabled?: boolean): React.CSSProperties => ({
  fontSize: Typography.Sizing.Default,
  fontWeight: 'normal',
  color: disabled ? Typography.Color.Disabled : Typography.Color.Primary,
  lineHeight: 'normal',
  cursor: 'default'
});

const labelMouseDownHandler = (e: React.MouseEvent) => {
  if (!(e.target instanceof HTMLInputElement)) {
    e.preventDefault();
  }
};

@InteractiveDomHoCDecorator
/** @deprecated this is not a very useful Widget. Please contact #dev-shared-widgets if you have a use case. */
export class InputLabelWidget extends React.Component<InputLabelProps, {}> {
  public render(): JSX.Element {
    return (
      <label
        className={this.props.className}
        data-tb-test-id={this.props.testId + '-Label'}
        id={this.props.id}
        style={{ ...getStyle(this.props.disabled), ...this.props.style }}
        onMouseDown={labelMouseDownHandler}
      >
        {this.props.children}
      </label>
    );
  }
}
